import React from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  VStack,
  Text,
  Box,
  HStack,
  Icon,
} from '@chakra-ui/react';
import { FiAlertTriangle, FiPhoneOff, FiMessageSquare } from 'react-icons/fi';

export default function DNCWarningAlert({ contactName, variant = 'full' }) {
  if (variant === 'compact') {
    return (
      <Alert status="error" size="sm" borderRadius="md">
        <AlertIcon />
        <Text fontSize="sm" fontWeight="semibold">
          Do Not Contact - Communication Blocked
        </Text>
      </Alert>
    );
  }

  return (
    <Alert 
      status="error" 
      variant="left-accent"
      borderRadius="lg"
      flexDirection="column"
      alignItems="flex-start"
      p={4}
    >
      <HStack spacing={2} mb={2}>
        <AlertIcon boxSize={5} />
        <AlertTitle fontSize="md" mb={0}>
          Do Not Contact (DNC)
        </AlertTitle>
      </HStack>
      
      <AlertDescription>
        <VStack align="flex-start" spacing={2} fontSize="sm">
          <Text>
            <Text as="span" fontWeight="bold">{contactName || 'This contact'}</Text> has
            been marked as <Text as="span" fontWeight="bold">Do Not Contact</Text>.
          </Text>
          
          <Box p={3} bg="red.50" borderRadius="md" w="full">
            <Text fontWeight="semibold" mb={2} fontSize="sm">
              The following actions are blocked:
            </Text>
            <VStack align="flex-start" spacing={1} fontSize="xs">
              <HStack>
                <Icon as={FiPhoneOff} color="red.600" />
                <Text>Phone calls</Text>
              </HStack>
              <HStack>
                <Icon as={FiMessageSquare} color="red.600" />
                <Text>Text messages (SMS)</Text>
              </HStack>
            </VStack>
          </Box>

          <Text fontSize="xs" color="gray.600" mt={2}>
            You can still email this contact or update their deal information.
            To remove DNC status, edit the contact details.
          </Text>
        </VStack>
      </AlertDescription>
    </Alert>
  );
}

